import { ReactNode, useEffect } from "react";
import { useLocation } from "react-router";

interface PropsType {
  children: ReactNode;
}

const ScrollToTop = (props: PropsType) => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return <>{props.children}</>;
};

export default ScrollToTop;
